const Initreducer = (state, { type, payload }) => {
    switch (type) {
        case 'settoken':
            return { ...state, token: payload, islogin: true };
        case 'setinit':
            return { ...state, loading: false, user: payload.user, role: payload.role, expense_type: payload.expense_type, active_expense_type: payload.active_expense_type, expense: payload.expense, category: payload.category, company: payload.company, customer: payload.customer, item: payload.item, service: payload.service, today_invoice: payload.today_invoice, return_item_company: payload.return_item_company, removeditem: payload.removeditem, expire_item: payload.expire_item };
        case 'setcompanyinvoiceitem':
            return { ...state, company_invoice_item: payload };
        case 'setsellinvoice':
            return { ...state, today_invoice: payload };
        case 'setitem':
            return { ...state, item: payload };
        case 'setexpense_report':
            return { ...state, expense_report: payload };
        case 'setcompany_report':
            return { ...state, company_report: payload };
        case 'setcustomer_report':
            return { ...state, customer_report: payload };
        case 'setbroke':
            return { ...state, broke: payload };
        case 'setbrokereport':
            return { ...state, total_broke_qty: payload.total_broke_qty, total_broke_price: payload.total_broke_price };
        case 'filtercompanyinvoiceitem':
            return { ...state, company_invoice_item: state.company_invoice_item.filter((lis) => lis.company_invoice_id != payload) };
        case 'setsell_report':
            return { ...state, total_sell_qty: payload.total_sell_qty, total_sell_price: payload.total_sell_price, total_service_qty: payload.total_service_qty, total_service_price: payload.total_service_price, total_return_qty: payload.total_return_qty, total_return_price: payload.total_return_price };
        case 'setreturnbybarcode':
            return { ...state, returnbybarcode: payload };
        case 'setitemsellreport':
            return { ...state, item_sell_report_qty: payload.sell_qty, item_sell_report_price: payload.sell_price };
        case 'setreturnitemcompany':
            return { ...state, return_item_company: payload };
        case 'setsummaryreport':
            return { ...state, summary_report_sell_array: payload.summary_report_sell_array, summary_report_expense_amount: payload.summary_report_expense_amount, summary_report_damage_qty: payload.summary_report_damage_qty, summary_report_damage_amount: payload.summary_report_damage_amount, summary_report_return_item_company_qty: payload.summary_report_return_item_company_qty, summary_report_return_item_company_amount: payload.summary_report_return_item_company_amount, summary_report_total_service_price: payload.summary_report_total_service_price, summary_report_total_service_price_cash: payload.summary_report_total_service_price_cash, loan_out: payload.loan_out, loan_out_discount: payload.loan_out_discount, loan_in: payload.loan_in, loan_in_discount: payload.loan_in_discount, summary_report_total_return_price: payload.summary_report_total_return_price };
        case 'setservicereport':
            return { ...state, total_service_report_price: payload.total_service_report_price, total_service_report_qty: payload.total_service_report_qty };
        case 'loadingFalse':
            return { ...state, loading: false };
        case 'loadingTrue':
            return { ...state, loading: true };
        case 'authcheckFalse':
            return { ...state, authcheck: false };
        case 'authcheckTrue':
            return { ...state, authcheck: true };
        case 'setstok':
            return { ...state, stok: payload.stock, stock_amount: payload.stock_amount };
        case 'setcustomer_ledger':
            return { ...state, ledger_customer_id: payload.ledger_customer_id, ledger_customer_name: payload.ledger_customer_name };
        case 'setcompany_ledger':
            return { ...state, ledger_company_id: payload.ledger_company_id, ledger_company_name: payload.ledger_company_name };
        default:
            return state;
    }
}

export default Initreducer;